import React, { useEffect, useState } from 'react'
import Header from '../Header/Main'
import Breadcrumb from '../Breadcrumb/Main'
import Servicepage from '../Menservice/Servicepage'
import Footer from '../Footer/Main'
import { getStrapiData } from '../../api.controller'

function Main() {

    const [data, setData] = useState();

    useEffect(() => {
        getStrapiData("payroll-page").then(response => {
            console.log(response);
            setData(response.data);
        });
    }, []);

    return (
        <>
            <div className="page-wrapper">
                <Header />
                <Breadcrumb data={data} subtitle="Home" title="Payroll Outsourcing" />
                <section className="service-one service-one--page">
                    <div className="container">

                        <p>
                            By managing your workforce through outsourcing, we will provide an alternative to the high cost of retaining full time labour and a more effective staff management system for your workforce to meet your needs. With regards to your staff maintenance, initial training and replacement needs, they become our issue and no longer yours.

                        </p>
                        <h3 className="mt-4">
                            HR Outsourcing (Permanent and Temporary staff)
                        </h3>
                        <p>
                            Careers in Ghana (CIG) seek to ease the financial and administrative burdens that are often associated with the hiring of contract labour. Careers in Ghana (CIG) will take up the task of salary and payroll matters, so that your company can concentrate on the task at hand, and we will relieve your company of the monotonous and tedious job of managing payrolls. Based on the clients' project demands or assignment nature, the staff can be placed under our company's payroll.
                        </p>
                        <ul className="about-one__content__list">
                            <li>
                                <span className="fa fa-check-circle" />
                                Permanent Recruitment
                            </li>
                            <li>
                                <span className="fa fa-check-circle" />
                                Temporary Staffing
                            </li>
                            <li>
                                <span className="fa fa-check-circle" />
                                Payroll administration</li>
                            <li>
                                <span className="fa fa-check-circle" />
                                Maintenance of personnel database</li>
                            <li>
                                <span className="fa fa-check-circle" />
                                Provision of intranet service which set out HR policies</li>
                            <li>
                                <span className="fa fa-check-circle" />
                                Recruitment administration</li>
                            <li>
                                <span className="fa fa-check-circle" />
                                Routine training service</li>

                        </ul>

                        <h3 className="mt-4">Payroll Outsourcing</h3>
                        <p>
                            For any business, managing payroll is indeed a dreadful task as it consumes a lot of man hours and is not also income generating. Besides being cumbersome, it is also tiring as rules and regulations keep changing and therefore, software needs to be updated and employees are also required to abreast themselves with new tools. So to get away this tedious chore, why not outsource your payroll processing to Careers in Ghana? All you would need to do is provide us the payroll data and we will give you a viable, confidential, and accurate payroll processing service
                        </p>

                        <h3 className="mt-4">We deliver on:</h3>
                        <ul className="about-one__content__list">

                            <li>
                                <span className="fa fa-check-circle" />
                                Payroll processing that integrates with an accounting system. Payroll tax filing</li>
                            <li>
                                <span className="fa fa-check-circle" />
                                Employee self-service anytime, anywhere, from any device</li>
                            <li>
                                <span className="fa fa-check-circle" />
                                Employees pay options, including direct deposit, Mobile Money</li>
                            <li>
                                <span className="fa fa-check-circle" />
                                Year-end processing, bonuses</li>
                            <li>
                                <span className="fa fa-check-circle" />
                                Employee recordkeeping</li>
                            <li>
                                <span className="fa fa-check-circle" />
                                Ghana Revenue Authority (GRA) Services</li>
                            <li>
                                <span className="fa fa-check-circle" />
                                Social Security Administration</li>

                        </ul>


                    </div>
                </section>
                <Footer />
            </div>

        </>
    )
}

export default Main